// extracted by mini-css-extract-plugin
export default {"button":"CreateExceptionButton_button__5BnK5","content":"CreateExceptionButton_content__I45iy","icon":"CreateExceptionButton_icon__2QzNo"};